export default __webpack_public_path__ + "static/media/dalenrestaurant_thumb.7a28d405.jpg";